import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { GetPaymentService } from '../services/get-payment.service';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from "../services/constants.service";
import { CacheService } from '../services/cache.service';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-your-tip-jar',
  templateUrl: './your-tip-jar.component.html',
  styleUrls: ['./your-tip-jar.component.scss']
})
export class YourTipJarComponent implements OnInit {
  data: any;
  stripeEligibleCountry = this.constants.STRIPE_ELIGLIBLE_COUNTRY_LIST
  public countryCode: any;
  public isEligibleForPayment = false;
  public dropdown: any;
  public showNotEligible = false;
  public flag = false;
  public userdata: any;
  public isLoading: boolean;
  public userName: any;
  public user: any;
  public countryReselect = false;
  public sub: any;
  public totalAmount = 0;
  public getName: void;
  public newData: any;
  public PaymentCount = 0;
  public connectpage = false;
  public from = ""
  public reauth = false;
  public accountId;
  public nonHasTipped = false
  public paymentList;
  public showTips = false
  public isProcessing = false
  public checked = false
  public countryList = this.constants.COUNTRY_LIST_TXT
  public isKYCRequired = false
  public emailAddress = 'hello@window-swap.com';
  constructor(public constants: ConstantsService,
    private get_payment: GetPaymentService,
    private route: ActivatedRoute,
    private adminservice: AdminService,
    private _router: Router,
    private cache: CacheService,
    private spinner: SpinnerService,
  ) { }

  init() {
    this.get_payment.load(this.userName).then((result) => {
      this.data = result;
      if (Object.keys(this.data).length === 0) {
        this.dropdown = true;
        this.showNotEligible = false;
        this.connectpage = false;
        this.isLoading = false;
      } else {
        if (this.data.Item['isEligibleForPayment'] === true) {
          this.dropdown = false;
          this.showNotEligible = false;
          this.connectpage = true;
          this.isLoading = false;
          if (this.data.Item['accountId'] !== undefined) {
            if (this.data.Item['isConnectedToStripe'] === undefined) {
              this.accountId = this.data.Item['accountId'];
              this.reauth = true
              this.isLoading = false;
            }
            else {
              if (this.data.Item['receivePayment']) {
                this.checked = true
              }
              this.reauth = false
              this.connectpage = false;
              this.showTips = true
              this.isKYCRequired = this.data?.Item['isKYCUpdateRequired']
              this.getAllList()
            }
          }

        } else {
          this.showNotEligible = true;
          this.dropdown = false;
          this.connectpage = false;
          this.isLoading = false;
        }
      }
    })
  }
  async getAllList() {
    this.isLoading = true;
    await this.get_payment.getPaymentList(this.userName)
      .then((data) => {
        if (Object.keys(data['Items']).length === 1) {
          this.nonHasTipped = true;
          this.isLoading = false
        }
        else {
          this.paymentList = data['Items']
          this.PaymentCount = this.paymentList.length - 1
          this.paymentList.forEach(element => {
            if (element.creatorReceived !== undefined) {
              this.totalAmount += element.creatorReceived
              this.isLoading = false
            }
            if (element.amount !== undefined) {
              this.totalAmount += element.amount
              this.isLoading = false
            }
          });
          this.totalAmount = this.totalAmount / 100
        }
      })
  }
  async createpostData() {
    let data = {
      country: this.countryCode,
      isEligibleForPayment: this.isEligibleForPayment,
      creatorsEmail: this.userName,
      paymentId: "accept_payment",
    }
    await this.get_payment.createPayment(data)
      .then((data) => {
        this.init();
      })
  }
  async updatepostData() {
    let data = {
      country: this.countryCode,
      isEligibleForPayment: this.isEligibleForPayment,
      creatorsEmail: this.userName,
      paymentId: "accept_payment",
      countryReselect: this.countryReselect
    }
    await this.get_payment.updatepayment(data)
      .then((data) => {
        this.init();
        this.countryReselect = false;
      })
  }

  ngOnInit(): void {
    this.isLoading = true;
    let userDetails = this.adminservice.getSharedUserData()
    if (userDetails !== undefined) {
      this.userName = userDetails.email;
      this.user = userDetails.name;
      this.checkUrl()
    }
    else {
      this.cache.getAuthUser()
        .then(data => {
          let { given_name, email, userName, login } = data
          this.userName = given_name
          this.userName = email
          this.user = given_name
          this.getName = userName
          this.checkUrl()
          if (!login) {
            this._router.navigate(['/login'])
          }
          this.spinner.hide()
        })
        .catch(error => {
          this.spinner.hide()
        })
    }
  }
  async checkUrl() {
    this.isLoading = true
    let currentUrl = document.URL.split("/")
    let accountId
    this.from = currentUrl.slice(3).toLocaleString().toLowerCase()
    if (this.from === "user,return") {
      await this.get_payment.load(this.userName)
        .then(async (data) => {
          accountId = data["Item"].accountId
          let udata = {
            creatorsEmail: this.userName,
            paymentId: "accept_payment",
            ConnectedToStripe: true,
            countryReselect: true,
            receivePayment: false,
            returnAccountId: accountId
          }
          await this.get_payment.updatepayment(udata)
            .then((response) => {
              this._router.navigate(['/user/tipjar']);
            })
            .catch((error) => {
              this.isLoading = false
            })
        })
        .catch((error) => {
          this._router.navigate(['/user/tipjar']);
        })
    }
    else if (this.from === "user,reauth") {
      this._router.navigate(['/user/tipjar']);
    }
    else {
      this.init();
    }
  }
  selectCountry(country) {
    this.isLoading = true
    this.countryCode = country['countryCode'];
    for (let items of this.stripeEligibleCountry) {
      if (this.countryCode === items['countryCode']) {
        this.isEligibleForPayment = true;
        break;
      } else {
        this.isEligibleForPayment = false;
      }
    }
    if (!this.countryReselect) {
      this.createpostData();
    } else {
      this.updatepostData();
    }
  }
  open() {
    this.flag = !this.flag;
  }
  showDropdown() {
    this.dropdown = true;
    this.countryReselect = true;
    this.showNotEligible = false;
    this.isEligibleForPayment = false;
    this.flag = false;
  }
  async onClickConnectToStripe() {
    var openStripeConnect = window.open('', '_blank');
    openStripeConnect.document.write('Please wait...');
    this.isProcessing = true
    let data = {
      country: this.countryCode,
      creatorsEmail: this.userName,
      paymentId: "accept_payment"
    }
    await this.get_payment.updatepayment(data)
      .then((response) => {
        let connectUrl = response['data'].connectUrl
        openStripeConnect.location.href = connectUrl
        this.isProcessing = false
      })
      .catch((error) => {
        openStripeConnect.document.write(error.msg);
      })
  }
  async onClickReAuth() {
    var openStripeConnect = window.open('', '_blank');
    openStripeConnect.document.write('Please wait...');
    this.isProcessing = true
    let data = {
      existingAccountId: this.accountId,
      creatorsEmail: this.userName,
      paymentId: "accept_payment",
    }
    await this.get_payment.updatepayment(data)
      .then((response) => {
        this.init();
        let connectUrl = response['data'].connectUrl
        openStripeConnect.location.href = connectUrl
        this.isProcessing = false
      })
      .catch((error) => {
        openStripeConnect.document.write(error.msg);
      })
  }
  onclickreceivePayment(event) {
    this.checked = !this.checked
    this.isProcessing = true
    let data
    if (this.checked) {
      data = {
        receivePayment: true,
        creatorsEmail: this.userName,
        paymentId: "accept_payment",
      }
    }
    else {
      data = {
        receivePayment: false,
        creatorsEmail: this.userName,
        paymentId: "accept_payment",
        countryReselect: true,
      }
    }
    this.get_payment.updatepayment(data)
      .then((data) => {
        this.isProcessing = false
      })
      .catch((error) => {
        this.isProcessing = false
      })
  }
  search(event) {
    let value = event.target.value
    if (value === "") {
      this.countryList = this.constants.COUNTRY_LIST_TXT
    }
    else {
      this.countryList = this.constants.COUNTRY_LIST_TXT.filter(res => {
        return res.countryName.toLowerCase().match(value.toLowerCase());
      })
    }
  }
  onClickOpenFeeInfo() {
    document.getElementById("popup").style.display = "flex"
  }
  onClickCloseFeeInfo() {
    document.getElementById("popup").style.display = "none"
  }
}
